<template>
  <b-tooltip
    :label="tooltipLabel"
    :active="tooltipActive"
    :position="$media.desktop && !isRight ? 'is-left' : 'is-right'"
    type="is-black"
  >
    <span class="difficulty-icon is-size-7">
      <span
        class="difficulty-icon__line difficulty-icon__line--1"
        :class="{ 'difficulty-icon__line--active': difficulty >= 1 }"
      ></span>
      <span
        class="difficulty-icon__line difficulty-icon__line--2"
        :class="{ 'difficulty-icon__line--active': difficulty >= 2 }"
      ></span>
      <span
        class="difficulty-icon__line difficulty-icon__line--3"
        :class="{ 'difficulty-icon__line--active': difficulty >= 3 }"
      ></span>
    </span>
  </b-tooltip>
</template>

<script>
import EnumHelper from '@/helpers/enums'
import { INDICATOR_DIFFICULTY_EASY, INDICATOR_DIFFICULTY_MEDIUM, INDICATOR_DIFFICULTY_HARD } from '@/consts/enums'

export default {
  props: {
    indicator: Object,
    isRight: Boolean
  },
  computed: {
    difficulty() {
      switch (this.indicator.difficulty) {
        case INDICATOR_DIFFICULTY_EASY:
          return 1
        case INDICATOR_DIFFICULTY_MEDIUM:
          return 2
        case INDICATOR_DIFFICULTY_HARD:
          return 3
        default:
          return 0
      }
    },
    tooltipLabel() {
      const difficulties = [INDICATOR_DIFFICULTY_EASY, INDICATOR_DIFFICULTY_MEDIUM, INDICATOR_DIFFICULTY_HARD]
      if (difficulties.includes(this.indicator.difficulty)) {
        return EnumHelper.formatIndicatorDifficulty(this.indicator.difficulty)
      }
      return ''
    },
    tooltipActive() {
      return this.tooltipLabel.trim() !== ''
    }
  }
}
</script>

<style lang="scss">
.difficulty-icon {
  display: inline-block;
  white-space: nowrap;
  width: 22px;

  &__line {
    display: inline-block;
    border-right: 2px solid currentColor;
    margin-right: 3px;
    opacity: 0.3;

    &--1 {
      height: 4px;
    }

    &--2 {
      height: 8px;
    }

    &--3 {
      height: 12px;
    }

    &--active {
      opacity: 1;
    }
  }
}
</style>